export const EARTH_RADIUS = 6371000; // meters
export const EARTH_MASS = 5.97e24; // kg
export const G = 6.6743e-11; // gravitational constant

export const CANVAS_WIDTH = 800;
export const CANVAS_HEIGHT = 800;

export const EARTH_CANVAS_RADIUS = 250

; // pixels
export const EARTH_CENTER_X = CANVAS_WIDTH / 2;
export const EARTH_CENTER_Y = CANVAS_HEIGHT / 2;

export const EARTH_IMAGE_SIZE = EARTH_CANVAS_RADIUS * 2.3; // Slightly larger than the Earth circle
export const EARTH_IMAGE_OFFSET = 0; // Offset to center the image

export const MISSILE_MASS = 10000.0; // kg
export const DT = 0.1; // time step for simulation